let pendingCount = 0

export function incrementPendingRequests(): void {
  pendingCount += 1
}

export function decrementPendingRequests(): void {
  pendingCount = Math.max(0, pendingCount - 1)
}

export function hasPendingRequests(): boolean {
  return pendingCount > 0
}
